import { EVENTS } from 'common/domain/constants';

export default class HelperDelegationsService {
  constructor($rootScope, $q, $transitions) {
    'ngInject';
    this.rootScope = $rootScope;
    this.q = $q;
    this.transitions = $transitions;
    this.visited = {};
  }

  isDelegationEmpty(delegation) {
    return Object.keys(delegation).length === 0;
  }

  setVisitedDelegation(employeeId, typeEmployee) {
    let employeeHash = this._getEmployeeHash(employeeId, typeEmployee);
    this.visited[employeeHash] = true;
  }

  getVisitDelegation(employeeId, typeEmployee) {
    let employeeHash = this._getEmployeeHash(employeeId, typeEmployee);
    return this.visited[employeeHash] === true;
  }

  _getEmployeeHash(employeeId, typeEmployee) {
    return `${typeEmployee}${employeeId}`;
  }

  sendEventToChangeIconDelegations() {
    this.rootScope.$broadcast(EVENTS.ICON_DELEGATIONS, {});
  }

  onSearchEmployeeDelegations(employees) {
    const deferred = this.q.defer();
    deferred.resolve(employees);
    return deferred.promise;
  }

}



// WEBPACK FOOTER //
// ./client/app/common/services/helperDelegations.service.js